<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Adhoc Vehicle Freight Approval</strong>
                    </div>
                    <div>
                    <b-row class="mb-5">
                      <h6>Requested Adhoc Plan</h6>
                        <b-table responsive show-empty :fields="fields" :items="vendorPendingRequest" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(row.item.requestid, pageNum)"><strong>{{ row.item.requestid }}</strong></button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="status" slot-scope="row">
                            <div>
                                <strong>{{ row.item.status }}</strong>
                            </div>
                        </template>
                        <template slot="basefreight" slot-scope="row">
                            <div>
                                <span v-if="row.item && row.item.basefreight" class="cutom-view-all-btn">{{ row.item.basefreight }}</span>
                                <span v-else class="cutom-view-all-btn">NA</span>
                            </div>
                        </template>
                        <template slot="vendorlist" slot-scope="row">
                            <div>
                                <button><i class="fa fa-clipboard" aria-hidden="true"></i></button>
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                        <!-- <template #table-caption><b>Incidents Listed</b></template> -->
                    </b-table>
                    </b-row>
                </div>   
                <b-row class="mb-5">
                  <b-col md="5">
                        <b-form-group label="Search Vendor :" :label-cols="3" class="mb-4">
                          <v-select
                          v-model="selected_vendor"
                          @input="searchVendoraName(requestId, selected_vendor && selected_vendor.vendorid)"
                          :options="vendorNameList"
                          label="transporter_name"
                          placeholder="-- Search Vendor --"
                          :custom-filter="filterVendor"
                        >
                          <!-- <template #option="option">
                            {{ option.transporter_name || 'No Name' }} (ID: {{ option.vendorid }})
                          </template> -->
                        </v-select>


                    </b-form-group>
                       </b-col>
                       <b-col md="7" class="text-right">
                        <b-button variant="primary" @click="viewAllLogs()"> View Logs </b-button>&nbsp;
                        <b-button variant="danger" @click="reconsiderRequest()"> Reconsider </b-button>&nbsp;
                       
                       </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="text-right" md='3'>
                            <button class="custom-Freight-lowest-price">Lowest Freight :- <span v-if="vendorInfoList && vendorInfoList[0] && vendorInfoList[0].basefreight">{{ vendorInfoList[0].basefreight  }}</span></button>
                        </div>
                        <b-table
                            responsive show-empty
                            :fields="fieldsFreight"
                            :items="vendorInfoList"
                            :filter="filter"
                            :busy="isBusy"
                            :sort-by.sync="sortByvendorInfo"
                            :sort-desc.sync="sortDescvendorInfo"
                            :sort-direction="sortDirectionvendorInfo"
                            caption-top
                            v-bind:responsive="false"
                          >
                          
                          <template slot="transporter_company_name" slot-scope="row">
                            <span v-if="!row.item.showDeleteIcon">
                                <span :class="{ 'custom-field-vendor': row.item.suggested_vendor === 'Yes' }"> {{ row.item.transporter_company_name }}</span>
                            </span>
                            <span v-if="row.item.showDeleteIcon === 1">
                              <v-select
                        v-model="selected_vendor_table"
                        @input="searchVendoraNameTable(requestId, selected_vendor_table && selected_vendor_table.vendorid)"
                        :options="vendorNameList"
                        label="transporter_comapany_name"
                        placeholder="-- Search Vendor --"
                        :custom-filter="filterVendor"
                      >
                        <!-- <template #option="option">
                          {{ option.transporter_comapany_name || 'No Name' }} (ID: {{ option.vendorid }})
                        </template> -->
                      </v-select>
                            </span>

                          </template>    
                            <template slot="totalloads" slot-scope="row">
                              <b-button class="custom-field-vendor" @click.prevent="approveVendor([row.item])">Approve Vendor</b-button>
                      <!--         
                              <span></span><b-button variant="secondary" class="custom-table-icon" @click="toggleStar(row.index)" size="sm">
                        <i :class="{'fa fa-star': true, 'text-warning': isStarred(row.index)}" aria-hidden="true"></i>
                      </b-button>&nbsp;
                              <span v-if="row && row.item && row.item.freight && row.item.freightp && !row.item.showDeleteIcon"><b-button variant="secondary" class="custom-table-icon" @click="editField(row.index)" size=sm><i class="fa fa-edit" aria-hidden="true"></i></b-button></span>&nbsp;    
                              <span v-if="row && row.item && row.item.freight && row.item.freightp && row.item.showDeleteIcon === 1"><b-button variant="secondary"  class="custom-table-icon" @click="addFreightInfirmation(row.item.transporter_name, row.item.freight)" size=sm><i class="fa fa-check" aria-hidden="true"></i></b-button>&nbsp;</span>
                              <span v-if="row.item.showDeleteIcon === 1"><b-button variant="secondary" class="custom-table-icon" @click="removeFreightDetails(row.index)" size=sm><i class="fa fa-trash" aria-hidden="true"></i></b-button>&nbsp;</span> -->
                          </template>

                          <!-- <template slot="freight" slot-scope="row">
                              <input v-model="row.item.freight" @input="changeFreightValue(row.index, row.item.freight)" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index) || row.item.suggested_vendor === 'Yes'}" disabled>
                          </template>  

                          <template slot="freightp" slot-scope="row">
                              <input v-model="row.item.freightp" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index) || row.item.suggested_vendor === 'Yes'}" disabled/>
                          </template> -->
                          <template slot="freight" slot-scope="row">
                              <input v-model="row.item.freight" @input="changeFreightValue(row.index, row.item.freight)" :class="{'custom-field-vendor': isStarred(row.index) || row.item.suggested_vendor === 'Yes'}" disabled>
                          </template>  

                          <template slot="freightp" slot-scope="row">
                              <input v-model="row.item.freightp" :class="{'custom-field-vendor': isStarred(row.index) || row.item.suggested_vendor === 'Yes'}" disabled/>
                          </template>

                            <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                        </b-table>

                        <b-row class="mt-3">
                          <b-col md=4>
                            <div class="mb-1">Suggested Reason</div>
                            <b-form-input
                              id="textarea-default"
                              placeholder="Enter Suggested Reason"
                              v-model.trim="suggested_reason"
                            ></b-form-input>
                          </b-col>
                          <b-col md="4">
                            <div class="mb-1"> Comment</div>
                            <b-form-input
                            id="textarea-default"
                            placeholder="Enter Comment"
                            v-model.trim="comment"
                          ></b-form-input>
                          </b-col>
                          <b-col md-4 class="test-center">
                            <div class="mb-3"></div>
                            <b-button variant="primary" @click="submitSuggestion()"> Submit </b-button>&nbsp;
                          </b-col>
                        </b-row>

                    </b-col>
                </b-row>
                    
                
                <div v-if="getAllSuggestionList.length > 0">

                  <b-table
                  responsive show-empty 
                  :fields="suggestionFields"
                  :items="getAllSuggestionList"
                  :filter="filter"
                  :busy="isBusy"
                  :sort-by.sync="sortBySuggestion"
                  :sort-desc.sync="sortDescSuggestion"
                  :sort-direction="sortDirectionSuggestion"
                  caption-top
                >
                <template slot="comment" slot-scope="row">
                  <span v-if="row.item.comment !== 'undefined' && row.item.comment !== undefined && row.item.comment !== 'null' && row.item.comment !== null && row.item.comment !== ''">
                    {{ row.item.comment }}
                  </span>
                    </template>  
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  </b-table>

                </div>
                </b-card>
               
            </b-col>
        </b-row>


        <!-- pending vehicle master start here-->
        <b-modal title="Add New Vendor" size="xl" v-model="updateInfo" @ok="updateInfo = false" hide-footer class="text-center">
          <div class="mb-5">
            <b-row class="mb-4">
              <div class="col-3">
                <strong>Vendor/Transporter Company Name:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Company Full Name"
                  v-model.trim="addVendorDetails.vendorCompanyName"
                  @change="validateCompanyName"
                ></b-form-input>
                <div v-if="errors.vendorCompanyName" class="text-danger">{{ errors.vendorCompanyName }}</div>
              </div>
            </b-row>

            <b-row class="mb-4">
              <div class="col-3">
                <strong>Vendor/Transporter Mobile No:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Mob No."
                  v-model.trim="addVendorDetails.vendorMobileNo"
                  maxlength="12"
                  @change="validateMobileNo"
                ></b-form-input>
                <div v-if="errors.vendorMobileNo" class="text-danger">{{ errors.vendorMobileNo }}</div>
              </div>
            </b-row>

            <b-row class="mb-4">
              <div class="col-3">
                <strong>Vendor/Transporter Email ID:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Email ID"
                  v-model.trim="addVendorDetails.vendorEmailId"
                  @change="validateEmail"
                ></b-form-input>
                <div v-if="errors.vendorEmailId" class="text-danger">{{ errors.vendorEmailId }}</div>
              </div>
            </b-row>

            <b-row class="mb-4">
              <div class="col-3">
                <strong>Add Freight:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Freight"
                  v-model.trim="addVendorDetails.addFreight"
                  @change="validateFreight"
                ></b-form-input>
                <div v-if="errors.addFreight" class="text-danger">{{ errors.addFreight }}</div>
              </div>
            </b-row>

            <b-row class="mb-4">
              <div class="col-3">
                <strong>GST No:</strong>&nbsp;<span style="color: red;">*</span>
              </div>
              <div class="col-6">
                <b-form-input
                  id="textarea-default"
                  placeholder="Please Enter Gst No"
                  v-model.trim="addVendorDetails.gstno"
                  @change="addGSTNumber"
                ></b-form-input>
                <div v-if="errors.gstno" class="text-danger">{{ errors.gstno }}</div>
              </div>
            </b-row>
          </div>
          <b-row>
            <b-col md="12" class="mb-5 text-center">
                <b-button variant="primary" @click="submitvenodr()"> Submit </b-button>&nbsp;
                <b-button variant="danger" @click="clearFilter(activeTab)"> Close </b-button>&nbsp;
            </b-col>
          </b-row>
        </b-modal>

        <!-- pending vehicle master end here -->

        <b-modal title="View Logs" v-model="viewLogsDetails" @ok="viewLogsDetails=false" hide-footer size="xl">
          <div>

            <b-table
            responsive show-empty 
            :fields="suggestionFields"
            :items="getAllSuggestionList"
            :filter="filter"
            :busy="isBusy"
            :sort-by.sync="sortByallSuggestionList"
            :sort-desc.sync="sortDescallSuggestionList"
            :sort-direction="sortDirectionallSuggestionList"
            caption-top
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            </b-table>

          </div>
        </b-modal>
    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Swal from 'sweetalert2';
export default {
  data() {
    return {
      requestId: null,  // Initialize to store the route param
      showpopup:'',
      fields : [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'totalloads', label : 'Total Loads', sortable: true},
                { key : 'totalmps', label : 'Total MPS', sortable: true},
                { key : 'totalvolwt', label : 'Total Vol. Wt(Tonn)', sortable: true},
                { key : 'lastmodifiedby', label : 'Last modified By & On', sortable: true},
                { key : 'createddate', label : 'Request Date', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'basefreight', label : 'Base Freight', sortable: true},
                { key : 'invoicevalue', label : 'Invoice Value', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'delivery_locations', label : 'Destination', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true}
        ],
        fieldsFreight: [ 
        { key: "basefreight", label: "Base Freight" , sortable: true},
        { key: "transporter_company_name", label: "Vendor Name" , sortable: true},
        { key: "freight", label: "Freight" , sortable: true},
        { key: "freightp", label: "Freight %" , sortable: true},
        { key: "totalloads", label: "Action" , sortable: true},
        ],
        vendorPendingRequest: [],
        vendorInfoList:[],
        selected_vendor: '',
        vendorNameList: [],
        vendorname: null,
        filter: "",
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",

      sortByvendorInfo: "",
      sortDescvendorInfo: false,
      sortDirectionvendorInfo: "asc",

      sortBySuggestion: "",
      sortDescSuggestion: false,
      sortDirectionSuggestion: "asc",

      sortByallSuggestionList: "",
      sortDescallSuggestionList: false,
      sortDirectionallSuggestionList: "asc",

      selected_vendor_table: '',
      allTransporterVenList: [],
      updateInfo:false,
      addVendorDetails: {
        vendorCompanyName: '',
        vendorMobileNo: '',
        vendorEmailId: '',
        addFreight: '',
        gstno: ''
      },
      errors: {
        vendorCompanyName: null,
        vendorMobileNo: null,
        vendorEmailId: null,
        addFreight: null,
        gstno: null
      },
      starredItems: [], // Array to keep track of which rows have a starred icon
      starredRows: [], // Array to store the indexes of starred rows
      suggestionFields: [ 
        { key: "createddate", label: "Log Date & Time" , sortable: true},
        { key: "createdby", label: "Log Updated By" , sortable: true},
        { key: "logtype", label: "Log Type" , sortable: true},
        { key: "transporter_company_name", label: "Vendor Suggested" , sortable: true},
        { key: "reason", label: "Reason" , sortable: true},
        { key: "comment", label: "Comment" , sortable: true},
        ],
      getAllSuggestionList: [],
      showDeleteIcon: 0,
      selectcsvFile: "",
      file: "",
      selectFiletype: "",
      acceptedloads: [],
      currentBidID: 0,
      outerBidID: false,
      viewLogsDetails:false,
    };
  },
  created() {
    // Access the dynamic 'id' from the route params
    this.requestId = this.$route.params.id;
    this.showpopup=this.$route.query.flag;
    if (this.requestId) {
      this.fetchAllFreightList(this.$route.params.id);
      this.allVendorList();
      this.allTransporterVendorList();
      // this.getAllSuggestion();
    }
  //   if (this.showpopup==='showpopup') {
  //     this.approveFreightAndVendorRequest()
  //  }
    // this.approveFreightAndVendorRequest()
  },
  mounted () {
    this.getAllSuggestion();
  },
  methods: {
    approveFreightAndVendorRequest() {
        if (this.$route && this.$route.params && this.$route.params.id === this.requestId ) {
            this.outerBidID = true
            this.outerApproveVendor(this.vendorInfoList)
        }
    },


    approveVendor(detail){
        console.log('in approve request',detail );
        // return false;
            // console.log(value,this.selectrequestid,this.selectapproverequest)
            let tableRows = '';
            // if (type==='checkAll') {
            //     this.selectapproverequest.forEach(plan => {
            //         tableRows += `
            //         <tr>
            //             <td>${plan.origin}</td>
            //             <td>${plan.route}</td>
            //             <td>${plan.vehicle_size}</td>
            //             <td>${plan.createdby}</td>
            //         </tr>
            //         `;
            //     });
            // }
            // if (type==='table') {
            //     this.selectrequestid = [];
            //     this.selectapproverequest =[];
            //     this.isCheckAll = false;
            //     let approvearray = [];
            //     approvearray.push(value)
               

            //     approvearray.forEach(plan => {
            //         tableRows += `
            //         <tr>
            //             <td>${plan.origin}</td>
            //             <td>${plan.route}</td>
            //             <td>${plan.vehicle_size}</td>
            //             <td>${plan.createdby}</td>
            //         </tr>
            //         `;
            //     });
            // }
            
          //  if (this.showpopup==='showpopup') {
            // console.log(" this.vendorInfoList", this.vendorInfoList)
            // this.vendorInfoList.forEach(plan => {
            //         tableRows += `
            //         <tr>
            //             <td>${plan.basefreight?plan.basefreight:''}</td>
            //             <td>${plan.transporter_company_name?plan.transporter_company_name:''}</td>
            //             <td>${plan.freight?plan.freight:''}</td>
            //         </tr>
            //         `;
            //     });
          //  }
                Swal.fire({
                  title: "<h3>Confirm Approval</h3><hr>",
                  html: `
                      Please confirm the approval of the below adhoc plans.
                      <br/><br/>
                      <table border="1" cellpadding="5" cellspacing="0" style="width:100%; text-align: left;" v-if='this.showpopup==='showpopup''>
                          <thead>
                              <tr>
                                  <th>Base Freight</th>
                                  <th>Vendor Name</th>
                                  <th>Freight</th>
                              </tr>
                          </thead>
                          <tbody>
                            
                                <tr>
                                    <td v-if="detail[0] && detail[0].basefreight">${detail[0].basefreight?detail[0].basefreight:''}</td>
                                    <td v-if="detail[0] && detail[0].transporter_company_name">${detail[0].transporter_company_name?detail[0].transporter_company_name:''}</td>
                                    <td v-if="detail[0] && detail[0].freight">${detail[0].freight?detail[0].freight:''}</td>
                                </tr>
                            
                        </tbody>
                      </table>
                  `,
                  showCancelButton: true,
                  confirmButtonText: "Confirm",
                  confirmButtonColor: "#00c0ef",
                  cancelButtonText: "Close",
                  cancelButtonColor: "#F8943F",
              })
            .then((result) => {
                console.log("result",result)
                // if (result.isConfirmed) {
                  if (result.value) {
                    this.loader=true;;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    // let result1 = ''
                    // result1 = this.vendorInfoList.find(item => item.suggested_vendor === 'Yes')

                const obj = {
                  requestid: this.requestId,
                  // bidid: result1 && result1.bidid ? result1.bidid : null,
                  bidid: detail &&  detail[0].bidid ? detail[0].bidid : null,
                  createdby: userInfo.userfirstname + userInfo.userlastname,
                  sysusermasterid: `${userInfo.sysusermasterid}`,
                  reason:  null
                }
                // console.log(obj, 'objetttt')
                // return false;

                    this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/approveVendorForRequest`,obj).then(result => {
                        this.loader=false;
                        if (result.body.returnmsg == "Successful") {
                            this.$fire({
                            text: "Request Approved Successfully!",
                            type: "success",
                            timer: 300000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            // this.getPendingList(1);
                            this.getAllSuggestion();
                        } else {
                            this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 300000,
                            });
                        }
                    })
                    .catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            })
            // row.item.requestid
    },

     //  approve Vendor
     
     outerApproveVendor(detail){
        console.log('in approve outer request',detail );
        // return false;
            // console.log(value,this.selectrequestid,this.selectapproverequest)
            let tableRows = '';
            // if (type==='checkAll') {
            //     this.selectapproverequest.forEach(plan => {
            //         tableRows += `
            //         <tr>
            //             <td>${plan.origin}</td>
            //             <td>${plan.route}</td>
            //             <td>${plan.vehicle_size}</td>
            //             <td>${plan.createdby}</td>
            //         </tr>
            //         `;
            //     });
            // }
            // if (type==='table') {
            //     this.selectrequestid = [];
            //     this.selectapproverequest =[];
            //     this.isCheckAll = false;
            //     let approvearray = [];
            //     approvearray.push(value)
               

            //     approvearray.forEach(plan => {
            //         tableRows += `
            //         <tr>
            //             <td>${plan.origin}</td>
            //             <td>${plan.route}</td>
            //             <td>${plan.vehicle_size}</td>
            //             <td>${plan.createdby}</td>
            //         </tr>
            //         `;
            //     });
            // }
            
          //  if (this.showpopup==='showpopup') {
          //   console.log(" this.vendorInfoList", this.vendorInfoList)
          //   // this.vendorInfoList.forEach(plan => {
          //   //         tableRows += `
          //   //         <tr>
          //   //             <td>${plan.basefreight?plan.basefreight:''}</td>
          //   //             <td>${plan.transporter_name?plan.transporter_name:''}</td>
          //   //             <td>${plan.freight?plan.freight:''}</td>
          //   //         </tr>
          //   //         `;
          //   //     });
          //  }
           const approveDetail =  this.vendorInfoList.find(item => item.suggested_vendor === 'Yes')
           console.log(approveDetail, 'approveDetailapproveDetail')
                Swal.fire({
                  title: "<h3>Confirm Approval</h3><hr>",
                  html: `
                      Please confirm the approval of the below adhoc plans.
                      <br/><br/>
                      <table border="1" cellpadding="5" cellspacing="0" style="width:100%; text-align: left;" v-if='this.showpopup==='showpopup''>
                          <thead>
                              <tr>
                                  <th>Base Freight</th>
                                  <th>Vendor Name</th>
                                  <th>Freight</th>
                              </tr>
                          </thead>
                          <tbody>
                                <tr>
                                    <td v-if="approveDetail && approveDetail.basefreight">${approveDetail.basefreight}</td>
                                    <td v-if="approveDetail && approveDetail.transporter_company_name">${approveDetail.transporter_company_name}</td>
                                    <td v-if="approveDetail && approveDetail.freight">${approveDetail.freight}</td>
                                </tr>
                        </tbody>
                      </table>
                  `,
                  showCancelButton: true,
                  confirmButtonText: "Confirm",
                  confirmButtonColor: "#00c0ef",
                  cancelButtonText: "Close",
                  cancelButtonColor: "#F8943F",
              })
            .then((result) => {
                console.log("result",result)
                // if (result.isConfirmed) {
                  if (result.value) {
                    this.loader=true;;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                if (this.outerBidID === true) {
                  detail[0].bidid = this.vendorInfoList[0].bidid
                } 

                const obj = {
                  requestid: this.requestId,
                  bidid: detail && detail[0].bidid ? detail[0].bidid : null,
                  createdby: userInfo.userfirstname + userInfo.userlastname,
                  sysusermasterid: `${userInfo.sysusermasterid}`,
                  reason: detail.suggested_vendor === 'Yes' ? null : null
                }
                // console.log(obj, 'objetttt')
                // return false;

                    this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/approveVendorForRequest`,obj).then(result => {
                        this.loader=false;
                        if (result.body.returnmsg == "Successful") {
                            this.$fire({
                            text: "Request Approved Successfully!",
                            type: "success",
                            timer: 300000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            // this.getPendingList(1);
                            this.getAllSuggestion();
                        } else {
                            this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 300000,
                            });
                        }
                    })
                    .catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            })
            // row.item.requestid
    },

    reconsiderRequest(value) {
            this.selectrequestid = [];
            this.selectapproverequest = [];
            this.isCheckAll = false;

            Swal.fire({
                title: "<h3>Request Reconsider</h3><hr>",
                html: `
                Please enter the reason for Reconsider.
                <br/><br/>
                <div style="display: flex; justify-content: space-around; align-items: center;">
                    <label for="reason" style="margin-right: 10px;"><strong>Reason:</strong></label>
                    <textarea id="reason" rows="4" style="width: 70%;"></textarea>
                </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Submit",
                confirmButtonColor: "#00c0ef",
                cancelButtonText: "Close",
                cancelButtonColor: "#F8943F",
                preConfirm: () => {
                    const reason = document.getElementById('reason').value;
                    if (!reason) {
                        Swal.showValidationMessage('Please enter a reason');
                    }
                    return { reason: reason };
                }
            }).then((result) => {
              console.log("===================>>>>>>>>>>>>>",result,this.vendorInfoList.suggested_vendor)
                // if (result.isConfirmed) {
                  if (result.value) {
                    this.loader = true;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    let result1 = ''
                    result1 = this.vendorInfoList.find(item => item.suggested_vendor === 'Yes')
                    // console.log(result1, 'result1result1')
                    const obj = {
                      requestid: this.requestId,
                      bidid: result1.bidid,
                        createdby: userInfo.userfirstname + " " + userInfo.userlastname,
                        // sysusermasterid: userInfo.sysusermasterid,
                        sysusermasterid: userInfo.sysusermasterid,
                        reason: result.value.reason,  // Use result.value.reason here
                    };
                    // console.log(obj, 'aaaaaaaaaaaaa detail')
                    // return false;
                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/markVendorReconsiderForRequest`, obj).then(result => {
                        this.loader = false;
                        if (result.body.returnmsg === "Successful") {
                            this.$fire({
                                text: "Request Successfully Rejected!",
                                type: "success",
                                timer: 3000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            // this.getPendingList(1);
                            this.getAllSuggestion();
                        } else {
                            this.$fire({
                                text: result.body.returnvalue,
                                type: "error",
                                timer: 3000,
                            });
                        }
                    }).catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            });
        },

    searchVendoraName(requestId, vendorname) {
        console.log(vendorname, 'vendorname', requestId)
        if(vendorname==null){
            this.selected_vendor="";
            this.fetchAllFreightList();
        } else {
            this.fetchAllFreightList(requestId, vendorname);
        }
    },

    fetchAllFreightList(requestId, vendorname) {
            // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: this.requestId,
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRequestSuggestedVendorFreight`,obj).then(result => {
                // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.vendorPendingRequest = result.body.returnvalue;
                    this.vendor_pending_count = this.vendorPendingRequest.length;
                    this.vendorInfoList = result.body.vendorinfo;
                    console.log(this.vendorInfoList, 'this.vendorInfoList@@12345')
                } else {
                    console.log('in else block');
                    this.vendor_pending_count = 0;
                    this.vendorPendingRequest = [];
                    this.vendorInfoList = []
                }
                if (this.showpopup==='showpopup') {
                    this.approveFreightAndVendorRequest()
                }
            })
            .catch((ex) => {
                console.log('in catch block');
                Swal.fire({
                    title:ex,
                    icon: "error",
                });
            });

    },

    // get vendor list of transpoter is already created
    allVendorList() {
            // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: this.requestId,
                type: null
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRegisteredVendorsList`,obj).then(result => {
                // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.vendorNameList = result.body.returnvalue.map(item => ({
                                    transporter_name: item.transporter_company_name + '-(ID :' + item.transporter_id+ ' )',
                                    vendorid: item.transporter_id
                                }));
                    console.log(this.vendorNameList, 'vendorNameList@@')
                } else {
                    this.vendorNameList = []
                }
            })
              .catch((ex) => {
                  console.log("error", ex);
                  Swal.fire({
                title:ex,
                icon: "error",
              });
            });
    },

    addFreight() {
        this.vendorInfoList.push({
        basefreight: (this.vendorPendingRequest && this.vendorPendingRequest.length > 0 && this.vendorPendingRequest[0].basefreight !== null) ?  (this.vendorPendingRequest[0].basefreight) : "NA",
        transporter_name: "",
        freight: "",
        freightp: "",
        showDeleteIcon: 1
      });
     
    },
    
    removeFreightDetails(index) {
        console.log('aa', index)
      this.vendorInfoList.splice(index, 1);
    },

    updateSelectedVendor(index, selectedVendor) {
      // Handle the vendor selection change if needed
      console.log(`Selected vendor for index ${index}: ${selectedVendor}`);
    },

    changeFreightValue(index, freightValue) {
        // Add 10 to the freight value and update freightp
        const freightNumber = freightValue;
        const invoiceValue = (this.vendorPendingRequest && this.vendorPendingRequest[0].invoicevalue) ? this.vendorPendingRequest[0].invoicevalue : 1
        if (!isNaN(freightNumber)) {
            this.vendorInfoList[index].freightp = ((freightNumber / invoiceValue) * 100).toFixed(2); // Update freightp
            console.log(this.vendorInfoList, 'this.vendorInfoList@@@@111');
        } else {
            this.vendorInfoList[index].freightp = ""; // Clear if input is invalid
        }
    },

    // add vendon for table
    allTransporterVendorList() {
        console.log('ok to vendor list')
        // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
              requestid: this.requestId,
                type: 'addvendor'
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRegisteredVendorsList`,obj).then(result => {
                // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log(result.body, 'aaaaaa');
                    // return false;
                    this.allTransporterVenList = result.body.returnvalue.map(item => ({
                                    transporter_name: item.transporter_name,
                                    vendorid: item.transporter_id
                                }));
                } else {
                    this.allTransporterVenList = []
                }
            })
            .catch((ex) => {
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    // add new freight
    addFreightInfirmation(transportername, freight) {
        console.log('transportername', 'transportername', transportername)
        console.log(this.allTransporterVenList, 'this.allTransporterVenList')
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const vendorInfo = this.allTransporterVenList.find(item => item.transporter_name === transportername.transporter_name)
            console.log(vendorInfo, 'vendorInfovendorInfo')
            let vendirid = null
            if (vendorInfo) {
                vendirid = vendorInfo.vendorid
            } else {
                vendirid = null
            }
            
            const freightInfo = {
              requestid: this.requestId,
                vendorid: vendirid,
                freight: freight,
                createdby: userInfo.userfirstname + " " + userInfo.userlastname,
            };
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addFreightForRequest`,freightInfo).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnvalue,
                        icon: "error",
                    });
                    this.fetchAllFreightList();
                    this.getAllSuggestion();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    // add vendor
    addVendor() {
        this.updateInfo = !this.updateInfo; 
    },

    // submitVendor 

    submitvenodr() {
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const vendorDetail = {
              companyname: this.addVendorDetails.vendorCompanyName,
              emailid: this.addVendorDetails.vendorEmailId,
              mobileno: this.addVendorDetails.vendorMobileNo,
              freight: this.addVendorDetails.addFreight,    
              gstno: this.addVendorDetails.gstno,          
              createdby: userInfo.userfirstname + " " + userInfo.userlastname,
              requestid: this.requestId,
              registered_from:'Admin_Portal_TM'
            };
            // console.log(vendorDetail, 'vendorDetail')
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addVendorForAdhocVehicleRequest`,vendorDetail).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnmsg,
                        icon: "success",
                    });
                    this.updateInfo = !this.updateInfo; 
                    this.fetchAllFreightList();
                    this.getAllSuggestion();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },


    // upload csv

    uploadcsvFile: function(event) {
      this.selectcsvFile = event.target.files[0];
        
      this.selectFiletype = event.target.files[0].type;
      
      console.log("selectFiletype", this.selectFiletype);
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
        if (this.selectFiletype == "text/csv") {
          let data = new FormData();
          data.append("file", this.selectcsvFile);
          // data.append("file", csvFile);
          data.append(
            "requestid",
            10
          );
          data.append("createdby", userInfo.userfirstname + " " + userInfo.userlastname);
          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addVendorsForAdhocVehicleRequestViaCsv`, data, {
              header: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                // alert("inn");
                this.$fire({
                  text: result.body.returnvalue,
                  type: "success",
                  timer: 30000,
                });
                // this.uploadcsvfilelisting(this.pageNum);

               
                var addzone = document.getElementById("addzone");
                addzone.style.display = "none";

                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
    },

    // suggestion

    toggleStar(index) {
      const rowIndex = this.starredRows.indexOf(index);
      if (rowIndex === -1) {
        // Add index to starredRows if not already present
        this.starredRows.push(index);
      } else {
        // Remove index from starredRows if already present
        this.starredRows.splice(rowIndex, 1);
      }
    },
    isStarred(index) {
      return this.starredRows.includes(index); // Check if the row is starred
    },

    // submit suggestion
    submitSuggestion () {
      document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const markSuggestion = {
              requestid: this.requestId,
              bidid: this.currentBidID ? this.currentBidID : null,
                  reason: this.suggested_reason,
                  comment: this.comment,
                  createdby: userInfo.userfirstname + " " + userInfo.userlastname,
                  sysusermasterid: userInfo.sysusermasterid
            };

            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/markVendorAsSuggestion`,markSuggestion).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnmsg,
                        icon: "success",
                    }); 
                    this.fetchAllFreightList();
                    this.getAllSuggestion();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },
    

    // get all suggestion here
    getAllSuggestion() {
      console.log('ok to vendor list')
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
              requestid: this.requestId,
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRequestLogs`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log(result.body, 'aaaaaa');
                    // return false;

                    this.getAllSuggestionList = result.body.returnvalue
                } else {
                    this.getAllSuggestionList = []
                }
            })
            .catch((ex) => {
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

   
    // approveVendor (detail) {
    //   console.log('ok to vendor list', detail)
    //     document.getElementById("overlay").style.display = "block";
    //         var userdata = localStorage.getItem("userData");
    //         var userInfo = JSON.parse(userdata);
    //         let vendorReason = null
    //         if (detail.suggested_vendor === 'Yes') {
    //           vendorReason  = null
    //         } else {
              
    //         }

    //         const obj = {
    //           requestid: this.requestId,
    //           bidid: this.vendorInfoList && this.vendorInfoList[0] ? this.vendorInfoList[0].bidid : null,
    //           createdby: userInfo.userfirstname + userInfo.userlastname,
    //           sysusermasterid: `${userInfo.sysusermasterid}`,
    //           reason: "Not approved suggested vendor becoz his freigt is more."  -------> Pass null in case of suggested_vendor='Yes'
    //         },
            

    //         // return false
    //         this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRequestLogs`,obj).then(result => {
    //             document.getElementById("overlay").style.display = "none";
    //             if (result.body.returnmsg === 'Successful') {
    //                 console.log(result.body, 'aaaaaa');
    //                 // return false;

    //                 this.getAllSuggestionList = result.body.returnvalue
    //             } else {
    //                 this.getAllSuggestionList = []
    //             }
    //         })
    //         .catch((ex) => {
    //             console.log("error", ex);
    //             Swal.fire({
    //           title:ex,
    //           icon: "error",
    //         });
    //         });
    // },

    searchVendoraNameTable(requestId, vendorname) {
        console.log(vendorname, 'vendornametable', requestId)
        if(vendorname==null){
            this.selected_vendor_table="";
            // this.fetchAllFreightListTable();
        } else {
            // this.fetchAllFreightListTable(requestId, vendorname);
        }
    },

    // validation start here

    // Validation methods
    validateCompanyName() {
        console.log('ok12871');
      if (!this.addVendorDetails.vendorCompanyName) {
        this.errors.vendorCompanyName = 'Company name is required';
      } else {
        this.errors.vendorCompanyName = null;
      }
    },

    validateMobileNo() {
      const mobilePattern = /^[0-9]{10,12}$/;
      if (!mobilePattern.test(this.addVendorDetails.vendorMobileNo)) {
        this.errors.vendorMobileNo = 'Please enter a valid mobile number';
      } else {
        this.errors.vendorMobileNo = null;
      }
    },

    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.addVendorDetails.vendorEmailId)) {
        this.errors.vendorEmailId = 'Please enter a valid email address';
      } else {
        this.errors.vendorEmailId = null;
      }
    },
    
    validateFreight() {
      if (!this.addVendorDetails.addFreight || isNaN(this.addVendorDetails.addFreight)) {
        this.errors.addFreight = 'Freight should be a valid number';
      } else {
        this.errors.addFreight = null;
      }
    },

    addGSTNumber() {
      // Regular expression for validating GST number format (India)
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      // Clear previous error
      this.errors.gstno = null;

      // Validation rules
      if (!this.addVendorDetails.gstno) {
        // Check if GST number is empty
        this.errors.gstno = "GST number is required.";
      } else if (!gstRegex.test(this.addVendorDetails.gstno)) {
        // Check if GST number matches the regex pattern
        this.errors.gstno = "Invalid GST number format.";
      }
    },
    
    viewAllLogs(){
      this.getAllSuggestionList = []
      this.viewLogsDetails =! this.viewLogsDetails;
      if (this.viewLogsDetails) {
        this.getAllSuggestion();
      }
      
    },
  }
}

</script>

<style scoped>
.tab-content {
margin-top: 20px;
}

.nav-link {
    color: #6c757d;  /* Customize the text color */
    background-color: #f8f9fa; /* Customize the background */
    border-color: #dee2e6;    
}
.tabs .nav-tabs {
    display: flex;
    justify-content: center; /* Centers the tabs horizontally */
    align-items: center; /* Centers the content vertically */
}


.custom-outer-filter {
    padding-top: 25px;
    padding-left: 15px;
}


.cutom-view-all-btn {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
background-color: #E8E4E4 !important;
padding: 4px !important;
}

.cutom-view-all-btn:focus {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
outline: none !important;
background-color: #E8E4E4 !important;
box-shadow: none !important;
padding: 4px !important;
}

.nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}


.nav-link {
        background: #7B7B7B !important;
        border-radius: 20px;
        border: none;
    }
    .nav-link.active {
        background: #F8943F !important;
    border-radius: 20px;
    border: none;
  }

  .nav-tabs {
    border-bottom: none !important;
}

.custom-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.custom-link i {
    font-size: 24px; /* Adjust icon size */
    margin-bottom: 5px; /* Add space between icon and text */
    color: #fff; /* Set icon color to white */
}

.custom-link div {
    font-size: 16px; /* Adjust text size */
    color: #fff !important;
}
.cutom-view-plan-btn {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}
.cutom-view-plan-btn:focus {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}

.modal-center-title .modal-header {
    justify-content: center;
    width: 100%;
}

.modal-center-title .modal-title {
    text-align: center;
    width: 100%;
}
.custom-Freight-lowest-price {
    background-color: #C0EA47 !important;
    color: 000 !important;
    padding: 5px !important;
    border: none !important;
}
.custom-Freight-lowest-price:focus {
    background-color: #C0EA47 !important;
    color: 000 !important;
    padding: 5px !important;
    border: none !important;
    outline: none !important;
}
.custom-field-vendor {
  background-color: #C0EA47 !important;
    color: 000 !important;
}
.custom-table-icon {
  background: none !important;
  border: none !important;
  outline: none;
}
.custom-table-icon:focus {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom-table-icon:active{
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom-table-close-btn .clear {
    /* Add your styles here */
    background: none !important;
    background-color: none !important;
    color: #b0c4de !important;
}



</style>